var map = {
	"./help-centre/app.config.js": 3347,
	"./login/app.config.js": 9469,
	"./myaccount/app.config.js": 2939,
	"./players/app.config.js": 4402,
	"./search/app.config.js": 3540,
	"./store/app.config.js": 5931
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5595;